import React from "react"
import {
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native"
import { Badge } from "react-native-elements"

import Base from "../../base"

export default function OrdersHeaderButton(props) {
  const titleStyle = props.selected ? styles.selectedTitle : styles.title
  const containerStyle = [
    styles.container,
    {
      borderBottomColor: props.selected ? Base.colours.appRed : "transparent",
      marginHorizontal: props.isMobile ? 0 : 16,
    },
  ]

  return (
    <TouchableOpacity
      style={[styles.main, props.isMobile && styles.main_sm]}
      onPress={() => props.onChanged(props.index)}
    >
      <View style={containerStyle}>
        <View>
          <Text style={titleStyle}>{props.title}</Text>
          {+props.index === 0 && props.pendingCount > 0 && (
            <Badge
              badgeStyle={styles.badge}
              value={props.pendingCount}
              textStyle={[
                styles.badgeText,
                Platform.OS === "web" && styles.badgeTextWeb,
              ]}
              containerStyle={styles.badgeContainer}
            />
          )}
        </View>
      </View>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  main: {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    height: 56,
  },

  main_sm: { marginHorizontal: 10 },

  container: {
    justifyContent: "center",
    alignItems: "center",
    borderBottomWidth: 2.0,
    paddingBottom: 2,
  },

  title: {
    justifyContent: "center",
    fontFamily: Base.fonts.appExtraBold,
    color: Base.colours.appDarkBlue,
    opacity: 0.5,
    fontSize: 16,
  },

  selectedTitle: {
    justifyContent: "center",
    fontFamily: Base.fonts.appExtraBold,
    color: Base.colours.appRed,
    fontSize: 16,
  },

  badge: {
    backgroundColor: Base.colours.appRed,
    minWidth: 16,
    height: 16,
    borderRadius: 8,
  },

  badgeText: { fontFamily: Base.fonts.appBold, fontSize: 11 },
  badgeTextWeb: { position: "absolute", top: -1 },
  badgeContainer: { position: "absolute", top: -8, right: -17 },
})
